import { render, staticRenderFns } from "./addform.vue?vue&type=template&id=0b6275f4&scoped=true"
import script from "./addform.vue?vue&type=script&lang=js"
export * from "./addform.vue?vue&type=script&lang=js"
import style0 from "./addform.vue?vue&type=style&index=0&id=0b6275f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6275f4",
  null
  
)

export default component.exports